import moment from 'moment';
import React, { memo, useEffect } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import { Button } from 'nike-ui/src/components/button/Button';
import EmptyState from 'nike-ui/src/components/empty-state/EmptyState';
import i18n from '@i18n';
import MessageIcon from '@/icons/MessageIcon';
import BlockLoader from '@/ui/BlockLoader';
import PopupNg from '@/ui/PopupNg';
import { fireGAEvent } from '@/analytics';
import { deleteAccountMessage, loadAccountMessage } from '@/message/handlers';
import { accountMessage$, accountMessageLoading$ } from '@/message/subs';

/**
 *  Root path component; params: [spravaId]
 */
function AccountMessage({ spravaId, inDialog = false }) {
    useEffect(() => {
        if (spravaId) {
            dispatch(loadAccountMessage(spravaId));
        }
    }, [spravaId]);

    const { subscribe } = useReframe();
    const message = subscribe(accountMessage$(spravaId));
    const loading = subscribe(accountMessageLoading$);
    const stateIcon = <MessageIcon width={60} height={60} fill="#aab2bd" />;

    if (!message && loading) {
        return <BlockLoader />;
    }
    if (!message) {
        return <EmptyState stateIcon={stateIcon} text={i18n('jsp.profil.spravy.nenajdena')} />;
    }
    const { annotation, body, created, id, subject } = message;

    function deleteMessage() {
        if (inDialog) {
            PopupNg.dispatcher.close();
        }
        fireGAEvent('Spravy', 'Vymazat spravu');
        dispatch(deleteAccountMessage(id));
    }
    return (
        <div className="page-wrap user-section">
            <h1>{subject}</h1>
            <span>{moment(created).format('DD.MM.YYYY hh:mm:ss')}</span>
            <p>{annotation}</p>
            <p className="perex" dangerouslySetInnerHTML={{ __html: body }} />
            <Button primary={!inDialog} onClick={deleteMessage} label={i18n('jsp.profil.spravy.vymazat')} />
        </div>
    );
}

export default memo(AccountMessage);
